module.exports = __webpack_public_path__ + "static/img/banner2.701a88b5.png";